(() => {
  'use strict';
  const tr = s => (globalThis.mcT && globalThis.mcT[s]) || s, trf = (s, v) => tr(s).replace(/\{(\w+)\}/g, (_, k) => v[k]); // i18n: locales via snippets/meucompra-i18n-js.liquid
  const widget = document.querySelector('[data-assistant]');
  const configEl = document.querySelector('[data-assistant-config]');
  if (!widget || !configEl) return;
  let config;
  try { config = JSON.parse(configEl.textContent); } catch { return; }

  const $ = selector => widget.querySelector(selector);
  const panel = $('#assistant-panel'), launcher = $('[data-assistant-open]'), log = $('[data-assistant-log]');
  const chips = $('[data-assistant-chips]'), form = $('[data-assistant-form]'), input = $('[data-assistant-input]');
  const more = $('[data-assistant-more]');
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const normalize = value => String(value).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9\s-]/g, ' ').replace(/\s+/g, ' ').trim();
  let started = false, busy = false, searchVersion = 0;

  // Links stay inside the shop; product images may also come from Shopify's CDN.
  // The only e-mail link allowed is the public support address approved by the owner.
  const supportEmail = 'suporte@meucompra.shop';
  function safeUrl(value, image = false) {
    if (typeof value !== 'string' || !value.trim()) return '';
    try {
      const url = new URL(value, location.origin);
      if (url.protocol === 'mailto:') return !image && decodeURIComponent(url.pathname).toLowerCase() === supportEmail ? url.href : '';
      if (url.username || url.password || !['http:', 'https:'].includes(url.protocol)) return '';
      if (url.origin === location.origin) return url.href;
      return image && url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' ? url.href : '';
    } catch { return ''; }
  }
  function money(value) {
    const number = Number(value);
    return Number.isFinite(number) ? new Intl.NumberFormat('pt-BR', { style: 'currency', currency: document.body.dataset.currency || 'BRL' }).format(number) : '';
  }
  const el = (tag, className, text) => { const node = document.createElement(tag); if (className) node.className = className; if (text != null) node.textContent = text; return node; };
  const scrollToEnd = () => log.scrollTo({ top: log.scrollHeight, behavior: reducedMotion ? 'auto' : 'smooth' });

  function addMessage(from, text, links = [], products = []) {
    const bubble = el('div', `assistant-msg assistant-msg--${from}`);
    for (const paragraph of String(text).split('\n')) if (paragraph.trim()) bubble.append(el('p', '', paragraph));
    if (products.length) {
      const list = el('ul', 'assistant-products');
      for (const product of products) {
        const href = safeUrl(product.url);
        if (!href) continue;
        const item = el('li'), link = el('a', 'assistant-product');
        link.href = href;
        const image = safeUrl(product.image || product.featured_image?.url || '', true);
        if (image) { const img = el('img'); img.src = image; img.alt = ''; img.width = 48; img.height = 48; img.loading = 'lazy'; link.append(img); }
        const info = el('span', 'assistant-product-info');
        info.append(el('strong', '', product.title || tr('Produto')), el('span', '', product.available === false ? tr('Indisponível no momento') : money(product.price)));
        link.append(info); item.append(link); list.append(item);
      }
      if (list.children.length) bubble.append(list);
    }
    if (links.length) {
      const actions = el('div', 'assistant-links');
      for (const link of links) {
        const href = safeUrl(link.url);
        if (!href) continue;
        const anchor = el('a', link.primary ? 'assistant-link assistant-link--primary' : 'assistant-link', link.label);
        anchor.href = href;
        actions.append(anchor);
      }
      if (actions.children.length) bubble.append(actions);
    }
    log.append(bubble);
    scrollToEnd();
  }

  function showTyping() {
    const typing = el('div', 'assistant-msg assistant-msg--bot assistant-typing');
    typing.setAttribute('aria-label', tr('Compra Bot está digitando'));
    typing.append(el('span'), el('span'), el('span'));
    log.append(typing);
    scrollToEnd();
    return typing;
  }

  // Score each intent by its keywords found in the question; longer phrases weigh more ("taxa de entrega" beats "taxa").
  // Single words of 5+ letters also match as a prefix, so "entrega" covers "entregas"; short words ("oi") need an exact word.
  function matchIntent(question) {
    const text = ` ${normalize(question)} `, words = text.trim().split(' ');
    let best = null, bestScore = 0;
    for (const intent of config.intents || []) {
      const score = (intent.keywords || []).reduce((sum, keyword) => {
        const phrase = normalize(keyword);
        const found = phrase.includes(' ') || phrase.length < 5 ? text.includes(` ${phrase} `) : words.some(word => word.startsWith(phrase));
        return sum + (found ? phrase.split(' ').length : 0);
      }, 0);
      if (score > bestScore) { best = intent; bestScore = score; }
    }
    return best;
  }

  async function searchProducts(question) {
    const terms = normalize(question).replace(/\b(tem|tera|voces|vende|vendem|procuro|quero|comprar|um|uma|o|a|de|do|da|para|pra)\b/g, ' ').replace(/\s+/g, ' ').trim();
    if (terms.length < 3) return [];
    const version = ++searchVersion;
    const params = new URLSearchParams({ q: terms, 'resources[type]': 'product', 'resources[limit]': '3' });
    try {
      const response = await fetch(`${root}search/suggest.json?${params}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok || version !== searchVersion) return [];
      const data = await response.json();
      const products = data?.resources?.results?.products;
      return Array.isArray(products) ? products.slice(0, 3) : [];
    } catch { return []; }
  }

  // "#1001", "pedido 1001", "pedido nº 1001": the order number goes into the support e-mail subject.
  const orderNumber = question => (String(question).match(/#\s*(\d{3,})|pedido\D{0,6}(\d{3,})/i) || []).slice(1).find(Boolean) || '';
  function withEmailDraft(links, question) {
    const order = orderNumber(question), asked = !(config.suggestions || []).includes(question);
    return links.map(link => {
      if (!String(link.url).startsWith('mailto:')) return link;
      const params = new URLSearchParams({ subject: `${tr('Ajuda com meu pedido')}${order ? ` #${order}` : ''}`, body: `${tr('Número do pedido:')} ${order ? `#${order}` : ''}\n${tr('Minha dúvida:')} ${asked ? question : ''}\n` });
      return { ...link, url: `${link.url}?${params.toString().replace(/\+/g, '%20')}` };
    });
  }
  function reply(text, links, question) {
    const order = orderNumber(question), mail = links.some(link => String(link.url).startsWith('mailto:'));
    addMessage('bot', mail && order ? `${text}\n${trf('Vi o número #{order} na sua mensagem e já coloquei no assunto do e-mail.', { order })}` : text, withEmailDraft(links, question));
  }

  async function answer(question) {
    if (busy) return;
    busy = true;
    addMessage('user', question);
    const typing = showTyping();
    const intent = matchIntent(question);
    const products = intent ? [] : await searchProducts(question);
    await new Promise(resolve => setTimeout(resolve, reducedMotion ? 0 : 450));
    typing.remove();
    if (intent) reply(intent.text, intent.links || [], question);
    else if (products.length) addMessage('bot', tr('Encontrei estes produtos na loja:'), [{ label: tr('Ver todos os resultados'), url: `${config.searchUrl}?type=product&q=${encodeURIComponent(question)}` }], products);
    else reply(config.fallback.text, config.fallback.links || [], question);
    busy = false;
    showSuggestions(false);
  }

  // Every suggestion stays visible (they wrap, nothing scrolls sideways). After an answer they fold
  // behind one "Perguntas sugeridas" button so the conversation keeps the room.
  function renderChips() {
    chips.replaceChildren(...(config.suggestions || []).map(label => {
      const chip = el('button', 'assistant-chip', label);
      chip.type = 'button';
      chip.addEventListener('click', () => answer(label));
      return chip;
    }));
  }
  function showSuggestions(visible) {
    if (!more) return;
    chips.hidden = !visible;
    more.hidden = visible;
    more.setAttribute('aria-expanded', String(visible));
  }
  more?.addEventListener('click', () => { showSuggestions(true); chips.children[0]?.focus(); });

  function open() {
    panel.hidden = false;
    launcher.setAttribute('aria-expanded', 'true');
    widget.classList.add('is-open');
    if (!started) { started = true; addMessage('bot', config.greeting); renderChips(); }
    if (window.matchMedia('(hover: hover)').matches) input.focus();
  }
  function close() {
    panel.hidden = true;
    launcher.setAttribute('aria-expanded', 'false');
    widget.classList.remove('is-open');
    launcher.focus();
  }

  launcher.addEventListener('click', () => (panel.hidden ? open() : close()));
  $('[data-assistant-close]').addEventListener('click', close);
  panel.addEventListener('keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); close(); } });
  // On phones the open widget covers the page with a backdrop; tapping it closes the panel.
  widget.addEventListener('click', event => { if (event.target === widget && !panel.hidden) close(); });
  form.addEventListener('submit', event => {
    event.preventDefault();
    const question = input.value.trim().slice(0, 200);
    if (!question) return;
    input.value = '';
    answer(question);
  });
})();
